"use client";

import {
  DeleteCriteriaRequest,
  ExtractCriteriaRequest,
  MindstringPrototype,
} from "@/generated/fastapi";
import useCriteriaQuery from "../queries/useCriteriaQuery";
import useDeleteCriteriaMutation from "../mutations/useDeleteCriteriaMutation";
import useExtractCriteriaMutation from "../mutations/useExtractCriteriaMutation";

interface UseCriteriaBackendProps {
  targetId?: string | null;
  prototypeCategory?: MindstringPrototype | null;
}

export default function useCriteriaBackend({
  targetId,
  prototypeCategory,
}: UseCriteriaBackendProps) {
  const criteriaQuery = useCriteriaQuery({
    targetId,
    prototypeCategory,
  });
  const deleteCriteriaMutation = useDeleteCriteriaMutation({
    targetId,
    prototypeCategory,
  });
  const extractCriteriaMutation = useExtractCriteriaMutation({
    targetId,
    prototypeCategory,
  });

  async function handleDeleteCriteria(
    request: DeleteCriteriaRequest,
    onSuccess?: () => void,
  ) {
    const result = await deleteCriteriaMutation.mutateAsync(request);
    onSuccess?.();
    return result;
  }

  async function handleExtractCriteria(
    request: ExtractCriteriaRequest,
    onSuccess?: () => void,
  ) {
    const response = await extractCriteriaMutation.mutateAsync(request);
    onSuccess?.();
    return response;
  }

  return {
    criteria: {
      data: criteriaQuery.data ?? [],
      isLoading: criteriaQuery.isLoading,
      error:
        criteriaQuery.error instanceof Error
          ? criteriaQuery.error.message
          : criteriaQuery.error
            ? "Failed to load suggestions"
            : null,
      isExtracting: extractCriteriaMutation.isPending,
      initFetched: criteriaQuery.isFetched,
    },
    handleDeleteCriteria,
    handleExtractCriteria,
  };
}
